import { useDropzone } from 'react-dropzone';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
// type
import { UploadProps } from './type';
//
import Image from '../Image';
import RejectionFiles from './RejectionFiles';
import BlockContent from './BlockContent';
import { values } from 'lodash';

// ----------------------------------------------------------------------

const DropZoneStyle = styled('div')(({ theme }) => ({
  outline: 'none',
  overflow: 'hidden',
  position: 'relative',
  padding: theme.spacing(5, 1),
  borderRadius: theme.shape.borderRadius,
  transition: theme.transitions.create('padding'),
  backgroundColor: theme.palette.background.neutral,
  border: `1px dashed ${theme.palette.grey[500_32]}`,
  '&:hover': { opacity: 0.72, cursor: 'pointer' },
}));

// ----------------------------------------------------------------------

export default function UploadSingleFile({
  error = false,
  file,
  helperText,
  sx,
  name,
  ...other
}: UploadProps) {
  const { getRootProps, getInputProps, isDragActive, isDragReject, fileRejections } = useDropzone({
    multiple: false,
    ...other,
  });

  return (
    <Box sx={{ width: '100%', ...sx }}>
      <DropZoneStyle
        {...getRootProps()}
        sx={{
          ...(isDragActive && { opacity: 0.72 }),
          ...((isDragReject || error) && {
            color: 'error.main',
            borderColor: 'error.light',
            bgcolor: 'error.lighter',
          }),
          ...(file && {
            padding: '12% 0',
            paddingBottom: '40px',
          }),
        }}
      >
        <input {...getInputProps()} />

        <BlockContent />

        {file && name === 'image' && (
          <Image
            alt="file preview"
            src={typeof file === 'string' ? file : file.preview}
            sx={{
              top: 8,
              left: 8,
              borderRadius: 1,
              position: 'absolute',
              width: 'calc(100% - 16px)',
              height: 'calc(100% - 16px)',
            }}
          />
        )}

        {file && name === 'video' && (
          <iframe
            style={{
              height: '350px',
              width: '80%',
              margin: 'auto',
              display: 'flex',
            }}
            src={typeof file === 'string' ? file : file.preview}
            title="preview"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen;"
          ></iframe>
        )}

        {file && name === 'audio' && (
          <audio
            controls
            autoPlay
            src={typeof file === 'string' ? file : file.preview}
            style={{
              height: '100px',
              width: '80%',
              margin: 'auto',
              display: 'flex',
            }}
          ></audio>
        )}
      </DropZoneStyle>

      {/* {fileRejections.length > 0 && <RejectionFiles fileRejections={fileRejections} />} */}
      {fileRejections.length > 0 && <RejectionFiles fileRejections={[...fileRejections]} />}


      {helperText && helperText}
    </Box>
  );
}
